<script setup lang="ts">
import { computed } from 'vue'
import { Clock } from 'lucide-vue-next'

const props = defineProps<{
  date: string
  variant: 'raising' | 'closed' | 'exited'
}>()

const label = computed(() => {
  switch (props.variant) {
    case 'closed':
      return 'Closed On'
    case 'exited':
      return 'Exited On'
    default:
      return 'Closing Date'
  }
})
</script>

<template>
  <div class="mt-4 flex items-center justify-between rounded-lg bg-slate-800 px-4 py-3">
    <div class="flex items-center gap-2.5">
      <div class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-white/10">
        <Clock :size="18" class="text-white" />
      </div>
      <span class="text-sm font-medium text-slate-300">{{ label }}</span>
    </div>
    <span class="text-base font-medium text-white">{{ date }}</span>
  </div>
</template>
